var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentTemplate)?_c('div',_vm._l((_vm.rows),function(row,idx){return _c('t-key-value-data',{key:idx,attrs:{"item":row}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }